module.exports = __webpack_public_path__ + "ee42ed1070350b1cc92dacd3a7a9cfc8.svg";